module.exports = __webpack_public_path__ + "media/images/emblems/Morrens-coat_of_arms-37ac66ad8854053037436f98e3c1d80c.svg";